import { render, staticRenderFns } from "./InformationEmptyAboutCardNew.vue?vue&type=template&id=1ad4d0f1"
import script from "./InformationEmptyAboutCardNew.vue?vue&type=script&lang=ts"
export * from "./InformationEmptyAboutCardNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ad4d0f1')) {
      api.createRecord('1ad4d0f1', component.options)
    } else {
      api.reload('1ad4d0f1', component.options)
    }
    module.hot.accept("./InformationEmptyAboutCardNew.vue?vue&type=template&id=1ad4d0f1", function () {
      api.rerender('1ad4d0f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inforationCards/InformationEmptyAboutCardNew.vue"
export default component.exports